import React                   from 'react';
import PropTypes               from 'prop-types'
import {soldermask as tooltip} from 'pu-data/Tooltips';
import {
  solderSide as defaultSidesOptions,
  solderColor as defaultColorOptions,
}                              from 'pu-data/SelectOptions';
import SelectDualComponent     from './base/SelectDualComponent';

const Soldermask = props => (
  <SelectDualComponent
    {...props}
    label="Soldermask"
    required={props.required}
    tooltip={tooltip}
    nameA="solder_sides"
    defaultOptionsA={props.sidesOptions}
    nameB="solder_color"
    defaultOptionsB={props.colorOptions} />
);

Soldermask.defaultProps = {
  sidesOptions: defaultSidesOptions,
  colorOptions: defaultColorOptions,
  required: true,
};

Soldermask.propTypes = {
  parameters: PropTypes.object.isRequired,
  onChangeParameter: PropTypes.func.isRequired,
}

export default Soldermask;
